<div class="avi-main-header-tenant-selector">
    <avi-dropdown
        [options]="tenantOptions"
        name="tenant-selector"
        [(ngModel)]="selectedTenantRef"
        (ngModelChange)="handleTenantChange()"
        (optionsOpenedChange)="handleTenantDropdownOpenAndClose($event)"
        [required]="true"
        class="sel-avi-main-header-tenant-selector-dropdown"
    >
        <div
            aviDropdown_selectedValuesContainer
            class="avi-main-header-tenant-selector__selected-values-container"
        >
            <label
                class="avi-main-header-tenant-selector__tenant-view-label"
                for="avi-main-header-tenant-selector-selected-tenant-name"
            >
                {{ l10nKeys.tenantViewLabel | vtranslate }}
            </label>
            <div
                class="avi-main-header-tenant-selector__tenant-name"
                id="avi-main-header-tenant-selector-selected-tenant-name"
            >
                {{ selectedTenantName }}
            </div>
        </div>
    </avi-dropdown>
</div>
